import { render, staticRenderFns } from "./button.vue?vue&type=template&id=527710ba&scoped=true&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&id=527710ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527710ba",
  null
  
)

export default component.exports